import { SharedFunnelDatalayerEvent } from 'src/app/_services/types/datalayer.types';
import { InsuranceTypeEnum } from 'src/app/enums/insurance-type.enum';

import { BUSINESS_BASIC_FLOW_STEPS } from '../basic-shared-flow/constants';
import { BUSINESS_INSURANCE_STEPS, END_SCREEN_TEXTS } from '../company-insurance-constants';
import {
  BASIC_COMPANY_FLOW_INJECTION_TOKENS,
  BASIC_COMPANY_INSURANCE_BASE_URL,
  BASIC_COMPANY_INSURANCE_TYPE,
} from '../tokens/company-insurance-service.token';

/**
 * Since this business insurance flow will use the basic shared flow, we define the providers here
 * These providers will be removed and the constants will be reworked when fully implementing the flow
 */

export const BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE = 'pro/assurance-garantie-ouvrage';

export const BUSINESS_CONSTRUCTION_WARRANTY_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  product_category: 'Market',
  product_name: 'Entreprise_Garantie_ouvrage',
  funnel_complete: false,
  get event() {
    return `${this.product_name}_${this.product_category}`;
  },
};

export const BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA = {
  BASIC_FORM: {
    datalayer: {
      ...BUSINESS_CONSTRUCTION_WARRANTY_FUNNEL_EVENT_BASE,
      funnel_stage: 1,
      stage_name: 'Informations',
    },
  },
  OFFERS: {
    datalayer: {
      ...BUSINESS_CONSTRUCTION_WARRANTY_FUNNEL_EVENT_BASE,
      funnel_stage: 2,
      stage_name: 'Offres',
    },
    loginRoute: `${BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE}/${BUSINESS_BASIC_FLOW_STEPS.LOGIN.url}`,
    registerRoute: `${BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE}/${BUSINESS_BASIC_FLOW_STEPS.REGISTER.url}`,
    previous: `${BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE}/${BUSINESS_BASIC_FLOW_STEPS.OFFERS.url}`,
    next: `${BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE}/${BUSINESS_BASIC_FLOW_STEPS.END.url}`,
    endRoute: `${BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE}/${BUSINESS_BASIC_FLOW_STEPS.END.url}`,
  },
  LOGIN: {
    step: BUSINESS_BASIC_FLOW_STEPS.LOGIN.step,
    datalayer: {
      ...BUSINESS_CONSTRUCTION_WARRANTY_FUNNEL_EVENT_BASE,
      funnel_stage: 3,
      stage_name: 'Connexion',
    },
    previous: `${BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE}/${BUSINESS_BASIC_FLOW_STEPS.OFFERS.url}`,
    next: `${BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE}/${BUSINESS_BASIC_FLOW_STEPS.END.url}`,
  },
  REGISTER: {
    datalayer: {
      ...BUSINESS_CONSTRUCTION_WARRANTY_FUNNEL_EVENT_BASE,
      funnel_stage: 3,
      stage_name: 'Inscription',
    },
  },
  END: {
    datalayer: {
      ...BUSINESS_CONSTRUCTION_WARRANTY_FUNNEL_EVENT_BASE,
      funnel_complete: true,
      funnel_stage: 4,
      stage_name: 'Fin',
    },
    step: BUSINESS_INSURANCE_STEPS.END.step,
    steps: END_SCREEN_TEXTS,
  },
};

export const BUSINESS_CONSTRUCTION_WARRANTY_PROVIDERS = [
  {
    provide: BASIC_COMPANY_INSURANCE_TYPE,
    useValue: InsuranceTypeEnum.BUSINESS_CONSTRUCTION_WARRANTY,
  },
  {
    provide: BASIC_COMPANY_INSURANCE_BASE_URL,
    useValue: BUSINESS_CONSTRUCTION_WARRANTY_INSURANCE_BASE,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.formDatalayer,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.BASIC_FORM.datalayer,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.offersDatalayer,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.OFFERS.datalayer,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.endRoute,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.OFFERS.endRoute,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.offersLoginRoute,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.OFFERS.loginRoute,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.offersRegisterRoute,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.OFFERS.registerRoute,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.offersPreviousRoute,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.OFFERS.previous,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.offersNextRoute,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.OFFERS.next,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.loginStep,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.LOGIN.step,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.loginDatalayer,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.LOGIN.datalayer,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.loginPrevious,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.LOGIN.previous,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.loginNextRoute,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.LOGIN.next,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.registerDatalayer,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.REGISTER.datalayer,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.endScreenDatalayer,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.END.datalayer,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.endScreenStep,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.END.step,
  },
  {
    provide: BASIC_COMPANY_FLOW_INJECTION_TOKENS.endScreenSteps,
    useValue: () => BUSINESS_CONSTRUCTION_WARRANTY_ROUTING_DATA.END.steps,
  },
];
